import React from 'react';
import { Link } from 'react-router-dom';
import { coreStrengthsData } from '../data/mock';

const CoreStrengths = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container text-center">
          <h1 className="hero-large mb-6">Core Strengths & Capabilities</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Decades of proven experience delivering healthcare infrastructure excellence with unmatched accountability and expertise
          </p>
        </div>
      </section>

      {/* Core Strengths Grid */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {coreStrengthsData.map((strength) => (
              <div 
                key={strength.id}
                style={{
                  background: 'var(--bg-primary)',
                  padding: '48px',
                  borderRadius: '0px',
                  border: '1px solid var(--border-light)'
                }}
              >
                <h3 className="heading-1 mb-4">{strength.title}</h3>
                <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
                  {strength.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Detailed Capabilities */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium mb-12 text-center">Our Comprehensive Capabilities</h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Technical Expertise */}
            <div>
              <h3 className="heading-2 mb-6">Technical Expertise</h3>
              <div className="space-y-4">
                <div>
                  <h4 className="body-large mb-2" style={{ fontWeight: '700', fontFamily: "'Suisse Medium', sans-serif" }}>
                    Advanced Laboratory Infrastructure
                  </h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    Specialized capability in NBS Laboratory, BSL-2, and BSL-3 laboratory infrastructure for advanced medical research, virology, and diagnostic facilities.
                  </p>
                </div>

                <div>
                  <h4 className="body-large mb-2" style={{ fontWeight: '700', fontFamily: "'Suisse Medium', sans-serif" }}>
                    Modular Healthcare Infrastructure
                  </h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    Complete expertise in modular operation theatres, ICUs (MICU, SICU, Cardiac, Neuro, PICU, NICU, Trauma, Burns, Transplant, TB), radiology centers, cath labs, and specialized medical facilities.
                  </p>
                </div>

                <div>
                  <h4 className="body-large mb-2" style={{ fontWeight: '700', fontFamily: "'Suisse Medium', sans-serif" }}>
                    MEP Systems Excellence
                  </h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    Comprehensive mechanical, electrical, and plumbing systems including medical gas pipelines, HVAC, cleanrooms, and critical infrastructure.
                  </p>
                </div>
              </div>
            </div>

            {/* Project Management */}
            <div>
              <h3 className="heading-2 mb-6">Project Management Excellence</h3>
              <div className="space-y-4">
                <div>
                  <h4 className="body-large mb-2" style={{ fontWeight: '700', fontFamily: "'Suisse Medium', sans-serif" }}>
                    Single-Agency Accountability
                  </h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    Complete project responsibility from initial conceptualization through design, construction, commissioning, and long-term operations. One point of contact for seamless execution.
                  </p>
                </div>

                <div>
                  <h4 className="body-large mb-2" style={{ fontWeight: '700', fontFamily: "'Suisse Medium', sans-serif" }}>
                    Statutory Compliance Management
                  </h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    Complete management of statutory approvals, certifications, and ongoing compliance with national and international healthcare standards.
                  </p>
                </div>

                <div>
                  <h4 className="body-large mb-2" style={{ fontWeight: '700', fontFamily: "'Suisse Medium', sans-serif" }}>
                    Timely Delivery Assurance
                  </h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    Structured execution model ensuring quality, compliance, and timely delivery across all healthcare projects regardless of scale or complexity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Project Scale */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <h2 className="hero-medium mb-12 text-center">Scale & Capacity</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div 
              style={{
                background: 'var(--bg-primary)',
                padding: '40px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)',
                textAlign: 'center'
              }}
            >
              <div className="hero-large mb-4">3600</div>
              <h3 className="heading-2 mb-2">Bed Capacity</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                PG Institutes and Medical Colleges up to 3600 beds
              </p>
            </div>

            <div 
              style={{
                background: 'var(--bg-primary)',
                padding: '40px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)',
                textAlign: 'center'
              }}
            >
              <div className="hero-large mb-4">2500</div>
              <h3 className="heading-2 mb-2">Temporary Facilities</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Makeshift hospitals up to 2500 beds for emergency healthcare needs
              </p>
            </div>

            <div 
              style={{
                background: 'var(--bg-primary)',
                padding: '40px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)',
                textAlign: 'center'
              }}
            >
              <div className="hero-large mb-4">1000</div>
              <h3 className="heading-2 mb-2">ICU Capacity</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Temporary makeshift ICU hospitals up to 1000 beds
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Professional Team */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="hero-medium mb-4">Expert Professional Team</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
              Dedicated specialists with decades of proven experience across all levels of hospital facilities
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div 
              style={{
                background: 'var(--bg-secondary)',
                padding: '32px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)',
                textAlign: 'center'
              }}
            >
              <h3 className="heading-2 mb-2">Medical Professionals</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Doctors, specialists, and clinical experts
              </p>
            </div>

            <div 
              style={{
                background: 'var(--bg-secondary)',
                padding: '32px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)',
                textAlign: 'center'
              }}
            >
              <h3 className="heading-2 mb-2">Paramedical Staff</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Nurses, technicians, and support personnel
              </p>
            </div>

            <div 
              style={{
                background: 'var(--bg-secondary)',
                padding: '32px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)',
                textAlign: 'center'
              }}
            >
              <h3 className="heading-2 mb-2">Technical Experts</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Engineers, architects, and project managers
              </p>
            </div>

            <div 
              style={{
                background: 'var(--bg-secondary)',
                padding: '32px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)',
                textAlign: 'center'
              }}
            >
              <h3 className="heading-2 mb-2">Administrative Team</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Management and facility operations staff
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding cta-section-dark">
        <div className="container text-center">
          <h2 className="hero-medium mb-4 cta-heading-light">
            Experience Our Excellence
          </h2>
          <p className="body-large mb-8 cta-text-light">
            Partner with a team that brings unmatched expertise and accountability to healthcare infrastructure.
          </p>
          <Link 
            to="/contact" 
            className="btn-primary btn-light-on-dark"
          >
            Request Project Consultation
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CoreStrengths;
